"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tutorial.preview.title': 'Anteprima Tutorial',
    'tutorial.preview.introduction': 'Introduzione',
    'tutorial.preview.learningSteps': 'Passaggi di Apprendimento',
    'tutorial.preview.tutorialSections': 'Sezioni del Tutorial',
    'tutorial.preview.knowledgeEntries': 'voci di conoscenza',
    'tutorial.preview.sectionPrompt': 'Prompt della Sezione',
    'tutorial.preview.knowledgeBase': 'Base di Conoscenza',
    'tutorial.preview.stepSections': 'Sezioni del Passaggio',
    'tutorial.preview.notFound': 'Tutorial Non Trovato',
    'tutorial.preview.notFoundMessage': 'Il tutorial richiesto non è stato trovato o non hai il permesso di visualizzarlo.',
};
